import React from "react";
import "./LanguageChange.css";

function LanguageChange() {
  return (
    <>
      <p className="choose-lang">LANGUAGE: </p>
      <select name="language">
        <option value="ar">AR</option>
        <option value="en">EN</option>
        <option value="es">ES</option>
        <option value="fr">FR</option>
        <option value="gj">GJ</option>
      </select>
    </>
  );
}

export default LanguageChange;
